import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";

const NestErrorMessageCell: FC<
  DataTableCellChildComponentProps<NestTestResultError>
> = ({ content }) => {
  const { t } = useTranslation();
  return <>{t(content.message.key, content.message.parameters)}</>;
};

export default NestErrorMessageCell;
